/**
 * Scroll-Triggered Animations
 * Alpine.js directives for animating elements on scroll using Intersection Observer
 * - Retriggerable: Animations replay when scrolling back up and down
 * - Initial trigger: Animates on page load if element is already in viewport
 */

document.addEventListener('alpine:init', () => {
  // Fade In animation
  Alpine.directive('fade-in', (el, { expression }, { evaluate }) => {
    const options = expression ? evaluate(expression) : {};
    const delay = options.delay || 0;
    const duration = options.duration || 600;
    
    // Set initial hidden state
    const setHidden = () => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
    };
    
    // Set visible state
    const setVisible = () => {
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    };
    
    el.style.transition = `opacity ${duration}ms ease, transform ${duration}ms ease`;
    el.style.transitionDelay = `${delay}ms`;
    setHidden();
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisible();
        } else {
          // Reset when scrolling out of view (retriggerable)
          setHidden();
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    
    observer.observe(el);
  });
  
  // Slide In from Left
  Alpine.directive('slide-in-left', (el, { expression }, { evaluate }) => {
    const options = expression ? evaluate(expression) : {};
    const delay = options.delay || 0;
    const duration = options.duration || 600;
    
    const setHidden = () => {
      el.style.opacity = '0';
      el.style.transform = 'translateX(-50px)';
    };
    
    const setVisible = () => {
      el.style.opacity = '1';
      el.style.transform = 'translateX(0)';
    };
    
    el.style.transition = `opacity ${duration}ms ease, transform ${duration}ms ease`;
    el.style.transitionDelay = `${delay}ms`;
    setHidden();
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisible();
        } else {
          setHidden();
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    
    observer.observe(el);
  });
  
  // Slide In from Right
  Alpine.directive('slide-in-right', (el, { expression }, { evaluate }) => {
    const options = expression ? evaluate(expression) : {};
    const delay = options.delay || 0;
    const duration = options.duration || 600;
    
    const setHidden = () => {
      el.style.opacity = '0';
      el.style.transform = 'translateX(50px)';
    };
    
    const setVisible = () => {
      el.style.opacity = '1';
      el.style.transform = 'translateX(0)';
    };
    
    el.style.transition = `opacity ${duration}ms ease, transform ${duration}ms ease`;
    el.style.transitionDelay = `${delay}ms`;
    setHidden();
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisible();
        } else {
          setHidden();
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    
    observer.observe(el);
  });
  
  // Scale In animation
  Alpine.directive('scale-in', (el, { expression }, { evaluate }) => {
    const options = expression ? evaluate(expression) : {};
    const delay = options.delay || 0;
    const duration = options.duration || 600;
    
    const setHidden = () => {
      el.style.opacity = '0';
      el.style.transform = 'scale(0.9)';
    };
    
    const setVisible = () => {
      el.style.opacity = '1';
      el.style.transform = 'scale(1)';
    };
    
    el.style.transition = `opacity ${duration}ms ease, transform ${duration}ms ease`;
    el.style.transitionDelay = `${delay}ms`;
    setHidden();
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisible();
        } else {
          setHidden();
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    
    observer.observe(el);
  });
  
  // Stagger Children - animates children with delays
  Alpine.directive('stagger', (el, { expression }, { evaluate }) => {
    const options = expression ? evaluate(expression) : {};
    const staggerDelay = options.delay || 100;
    const duration = options.duration || 600;
    const selector = options.selector || '> *';
    
    const children = el.querySelectorAll(selector);
    
    const setHidden = () => {
      children.forEach((child, index) => {
        child.style.opacity = '0';
        child.style.transform = 'translateY(20px)';
        child.style.transition = `opacity ${duration}ms ease, transform ${duration}ms ease`;
        child.style.transitionDelay = `${index * staggerDelay}ms`;
      });
    };
    
    const setVisible = () => {
      children.forEach((child, index) => {
        child.style.opacity = '1';
        child.style.transform = 'translateY(0)';
        child.style.transitionDelay = `${index * staggerDelay}ms`;
      });
    };
    
    setHidden();
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisible();
        } else {
          setHidden();
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    
    observer.observe(el);
  });
});
